import { LangType } from 'common/constants';

export function getLangByPath(path = ''): LangType {
  if (path.startsWith('/kz/')) {
    return 'kk';
  }

  return 'ru';
}
